export default __webpack_public_path__ + "static/media/DartAnatomy.ca4cf6c2.png";